import {SERVICES} from '@/const/services';

export const UNIT_TYPES = {
  LOCAL_CURRENCY: 'LOCAL_CURRENCY',
  BTC: 'BTC',
  USDT: 'USDT',
};

export const ASSETS_TAB_TYPE = {
  OVERVIEW: 'overview',
  SPOT_WALLET: 'spot',
  MARGIN_TRADING_ACCOUNT: 'margin-trade',
  CONTRACT_ACCOUNT: 'contract',
  INVESTMENT_ACCOUNT: 'investment',
};

export const INVESTMENT_TAB_TYPE = {
  FLEXIBLE: 'flexible',
  FIXED: 'fixed',
  SAVINGS_TRIAL_FUND: 'savings_trial_fund',
  LAUNCHPOOL: 'launchpool',
  ACTIVITY: 'Activity',
  PREDICTION: 'Prediction',
};

export const IMAGES = {
  CONTRACT: `${SERVICES.STATIC_URL}/pubimg/6ecfc1bf8cd428cbe0be19ca9af054963e8c2f101da0f0839883de15eb0a98b3.png`,
  DISCORD: `${SERVICES.STATIC_URL}/pubimg/2736d12a084b5aade2e2fdec3a48f068cb5136187d7902052d6088992f7a8dd0.png`,
  SBTTEST: `${SERVICES.STATIC_URL}/pubimg/cfdddf78e1803ba64b806f7be81f056899ddc1e328cf801f4929394fa253b504.jpeg`,
  SPOT_ACCOUNT: `${SERVICES.STATIC_URL}/s/web/account/spot.svg`,
  CONTRACT_ACCOUNT: `${SERVICES.STATIC_URL}/s/web/account/contract.svg`,
  INVESTMENT_ACCOUNT: `${SERVICES.STATIC_URL}/s/web/account/investment.svg`,
  FIAT_ACCOUNT: `${SERVICES.STATIC_URL}/s/web/account/fiat_account.svg`,
  LENDING_ACCOUNT: 'https://img.phemex.com/v1/829e8664-5190-4690-ac11-cec9a116683f/lending-account.svg',
  MARGIN_ACCOUNT: `${SERVICES.STATIC_URL}/pubimg/0f13a181a5f87d62d620490c276f9a33638c5fb0df6aeece828028296c2c769c.png`,
  PILOT_CONTRACT_ACCOUNT: `https://img.phemex.com/v1/2fb83f6c-4009-4bef-9304-cf8a1d6e8d13/pilot-contract-account.png`,
  TELEGRAM: `${SERVICES.STATIC_URL}/pubimg/856f72e850e5b99ded18adbf3bae80f657f051f4640c292eaf6811da45b1d083.png`,
  FACEBOOK: `${SERVICES.STATIC_URL}/pubimg/9cee169afafc0a56bcbe71d559391ebe9b909950ee7fe50369ff1d1379ddd945.png`,
  TWITTER: `${SERVICES.STATIC_URL}/pubimg/ebe1e569754ba8f435cf5a544055e97de553af55f5d50a80e8d615ef7bcc0672.png`,
  LINKEDIN: `${SERVICES.STATIC_URL}/pubimg/db9366f85057d6c59a3d88505756100ec16605ee16abdeff7407d95c583a3210.png`,
  REDDIT: `${SERVICES.STATIC_URL}/pubimg/95ff654d0d6addbc89a07d38e3b9d2e514ee62a9e1235c285d007dc871125c67.png`,
  CITIZEN_CREST: `${SERVICES.STATIC_URL}/pubimg/3a28f5b5a805e8399b1886a9bb41f945bd54e82f87a004ed67da1e68b04f670a.png`,
  HASH_HAMMER: `${SERVICES.STATIC_URL}/pubimg/04fb7f4b5944bb32d3faa1ca5d4b27b48644fbb8477eff1275774d53d046724a.png`,
  BELIEVERS_PODIUM: `${SERVICES.STATIC_URL}/pubimg/1a768d5a6df063269834e13041e851be97cf2b3a1f2f2a6d09efb6784383c703.png`,
  SOUL_SHOVEL: `${SERVICES.STATIC_URL}/pubimg/b4571ebf644d7a89594e857881d4ae57888c3936b1579e1d19c4b1e247ada3e9.png`,
  INVITE_BG: `${SERVICES.STATIC_URL}/pubimg/1750f6d3efbb325d8d88abdabd784807114be9b7a1a75eed0908c49325c53ea3.png`,
  SHARE_BANNER: `${SERVICES.STATIC_URL}/pubimg/5b5c87fee59abbc386d770c1fc7ec8b609a162f743feb30e56ef1761a7d6f8d7.png`,
  TWITTER_V2: `https://img.phemex.com/v1/c80f707e-e491-410c-b9ed-e28fdf5e3d6c/twitter.svg`,
  FACEBOOK_V2: `${SERVICES.STATIC_URL}/s/web/media/facebook.svg`,
  TELEGRAM_V2: `${SERVICES.STATIC_URL}/s/web/media/telegram.svg`,
  LINKEDIN_V2: `${SERVICES.STATIC_URL}/s/web/media/linkin.svg`,
  REDDIT_V2: `${SERVICES.STATIC_URL}/s/web/media/reddit.svg`,
};
